import React, { useState } from "react";
import Swal from "sweetalert2";
import { FaRegEdit } from "react-icons/fa";
import { IoTrashBin } from "react-icons/io5";
import api from "../../services/api";
import { toast } from "react-toastify";
import "../Maps&Actions/styles.scss";
import Tooltip from "@mui/material/Tooltip";


// CAMPO EDITAVEL OBS
function CampoEditavel_Obs({
  equipamento,
  currentObs,
  setObsValues,
  id,
  campo
}) {
  const [isReadOnly, setIsReadOnly] = useState(true);

  return (
    <form className="d-flex align-items-start gap-1 form-campoEditavel obs">

      {/* ============================================================
          CAMPO DE OBSERVAÇÃO
      ============================================================ */}

      <textarea
        readOnly={isReadOnly}
        className="campo-edit_tabela_principal"
        value={currentObs || ""}
        style={{
          color:
            currentObs === "N/A"
              ? "#999"
              : undefined,

          fontStyle:
            currentObs === "N/A"
              ? "italic"
              : undefined,

          fontSize: "9.5pt",

          textAlign: "center",

          fontWeight:
            currentObs === "N/A"
              ? "normal"
              : 500,
        }}

        onChange={(e) =>
          setObsValues((prev) => ({
            ...prev,
            [equipamento]: e.target.value,
          }))
        }
      />

      {/* ============================================================
          BOTÃO EDITAR OBSERVAÇÃO
      ============================================================ */}

      <button
        type="button"
        className="botao-tabela-coluna_2 obs"

        onClick={async (e) => {
          e.preventDefault();

          /* ========================================================
             PRIMEIRA CONFIRMAÇÃO
          ======================================================== */
          const result = await Swal.fire({
            title: `Editar ${campo}`,
            text: "As alterações serão aplicadas imediatamente.",
            iconHtml: '<span class="icone-duvida-tech">?</span>',

            allowOutsideClick: false,
            showCloseButton: true,
            showCancelButton: true,

            confirmButtonText: "Continuar",
            cancelButtonText: "cancelar",

            customClass: {
              popup: "swal-edicao-tech",
              icon: "swal-edicao-icon",
              title: "swal-edicao-title",
              htmlContainer: "swal-edicao-text",
              actions: "swal-edicao-actions",
              confirmButton: "swal-edicao-confirm",
              cancelButton: "swal-edicao-cancel",
              closeButton: "swal-edicao-close",
            },

            buttonsStyling: false,

            reverseButtons: true,
          });


          /* ========================================================
             CANCELAR / FECHAR
          ======================================================== */

          if (!result.isConfirmed) {
            setIsReadOnly(true);
            return;
          }

          /* ========================================================
             LIBERA O CAMPO
          ======================================================== */

          setIsReadOnly(false);

          /* ========================================================
             MODAL DE EDIÇÃO
          ======================================================== */

          const {
            value: novoValor,
            isConfirmed,
            isDismissed,
          } = await Swal.fire({
            // =====================================================
            // MODAL DE EDIÇÃO DA OBSERVAÇÃO
            // MESMO ESTILO VISUAL DA DESCRIÇÃO
            // =====================================================

            title: "Pronto!",

            text: `Agora você pode editar o campo: ${campo}`,

            input: "textarea",

            inputValue:
              currentObs === "N/A"
                ? ""
                : currentObs || "",

            inputAttributes: {
              maxlength: 150,
            },

            allowOutsideClick: false,

            showCancelButton: true,
            showCloseButton: true,

            confirmButtonText: "Salvar",
            cancelButtonText: "Cancelar",

            // =====================================================
            // MESMO ESTILO DA CAMPOEDITAVEL_DESC
            // =====================================================

            buttonsStyling: false,

            customClass: {
              popup: "swal-editar-tech",
              title: "swal-editar-title",
              htmlContainer: "swal-editar-text",
              input: "swal-editar-input",
              actions: "swal-editar-actions",
              confirmButton: "swal-editar-confirm",
              cancelButton: "swal-editar-cancel",
              closeButton: "swal-editar-close",
            },

            // =====================================================
            // CONTADOR DE CARACTERES
            // =====================================================

            didOpen: () => {
              const textarea = Swal.getInput();

              if (!textarea) return;

              const counter = document.createElement("div");

              counter.className = "swal-editar-counter";

              const atualizarContador = () => {
                counter.textContent =
                  `${textarea.value.length} / 150`;
              };

              textarea.parentNode.appendChild(counter);

              atualizarContador();

              textarea.addEventListener(
                "input",
                atualizarContador
              );
            },
          });

          /* ========================================================
             SALVAR / CANCELAR
          ======================================================== */

          if (isConfirmed) {

            /* ======================================================
               VALOR VAZIO
            ====================================================== */

            if (!novoValor || novoValor.trim() === "") {

              const confirmEmpty = await Swal.fire({
                title: "Tem certeza?",

                text: `Isso apagará o dado anterior e deixará o campo ${campo} vazio.`,

                icon: "warning",

                customClass: {
                  popup: "confirma-edicao-obs",
                  htmlContainer: "swal2-html-container",
                },

                showCancelButton: true,

                confirmButtonText: "Sim, deixar vazio",
                cancelButtonText: "Cancelar",

                confirmButtonColor: "#2563eb",
                cancelButtonColor: "#9ca3af",
              });

              /* ====================================================
                 CONFIRMOU APAGAR
              ==================================================== */

              if (confirmEmpty.isConfirmed) {

                try {

                  console.log(
                    "========== SALVANDO OBSERVAÇÃO =========="
                  );

                  console.log(
                    "equipamento:",
                    equipamento
                  );

                  console.log(
                    "id enviado:",
                    id
                  );

                  console.log(
                    "valor:",
                    ""
                  );

                  /* ==================================================
                     ENVIA PARA O BACKEND

                     Exemplo:
                     id = 1660

                     PUT /obs/1660

                     {
                       obsValue: ""
                     }
                  ================================================== */

                  await api.put(
                    `obs/${id}`,
                    {
                      obsValue: ""
                    }
                  );

                  /* ==================================================
                     ATUALIZA O FRONT SOMENTE DEPOIS DO BANCO
                  ================================================== */

                  setObsValues((prev) => ({
                    ...prev,
                    [equipamento]: "",
                  }));

                  toast.success(
                    `Campo ${campo} apagado com sucesso`
                  );

                } catch (error) {

                  console.error(
                    "ERRO AO SALVAR OBSERVAÇÃO:",
                    error
                  );

                  console.error(
                    "STATUS:",
                    error.response?.status
                  );

                  console.error(
                    "DATA:",
                    error.response?.data
                  );

                  console.error(
                    "URL:",
                    error.config?.url
                  );

                  console.error(
                    "REQUEST:",
                    error.config?.data
                  );

                  toast.error(
                    error.response?.data?.error ||
                    error.response?.data?.message ||
                    "Erro ao salvar observação"
                  );
                }
              }

            } else {

              /* ====================================================
                 VALOR PREENCHIDO
              ==================================================== */

              const valorFinal = novoValor.trim();

              console.log(
                "========== SALVANDO OBSERVAÇÃO =========="
              );

              console.log(
                "equipamento:",
                equipamento
              );

              console.log(
                "id enviado:",
                id
              );

              console.log(
                "valor:",
                valorFinal
              );

              try {

                /* ==================================================
                   ENVIA PARA O BACKEND

                   Exemplo:

                   PUT /obs/1660

                   {
                     obsValue: "Nova observação"
                   }
                ================================================== */

                console.log("===== SALVANDO OBS =====");
                console.log("equipamento:", equipamento);
                console.log("id:", id);
                console.log("valor:", valorFinal);

                await api.put(`obs/${equipamento}`, {
                  obsValue: valorFinal
                });

                /* ==================================================
                   ATUALIZA O FRONT SOMENTE SE SALVOU NO BANCO
                ================================================== */

                setObsValues((prev) => ({
                  ...prev,
                  [equipamento]: valorFinal,
                }));

                toast.success(
                  `Alteração no campo: ${campo} salva com sucesso!`
                );

              } catch (error) {

                console.error(
                  "ERRO AO SALVAR OBSERVAÇÃO:",
                  error
                );

                console.error(
                  "STATUS:",
                  error.response?.status
                );

                console.error(
                  "DATA:",
                  error.response?.data
                );

                console.error(
                  "URL:",
                  error.config?.url
                );

                console.error(
                  "REQUEST:",
                  error.config?.data
                );

                toast.error(
                  error.response?.data?.error ||
                  error.response?.data?.message ||
                  `Erro ao salvar ${campo}`
                );
              }
            }

            setIsReadOnly(true);

          } else if (isDismissed) {

            setIsReadOnly(true);

          } else {

            setIsReadOnly(true);
          }
        }}
      >
      </button>

    </form>
  );
}

// -------------------------------------------------------------------------------------------



// COMPONENTE TABELA PRINCIPAL COLUNA DESCRIÇÃO
function CampoEditavel_Desc({ equipamento, currentNome, setNomeValues, id, campo }) {
  const [isReadOnly, setIsReadOnly] = useState(true);

  return (
    <form className="dados-campo-desc"

    >

      <textarea
        readOnly={isReadOnly}
        value={currentNome}
        style={{
          width: "100%",
          boxSizing: "border-box",
          outline: "none",

          textAlign: "left",
          background: "none",



          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",

          overflow: "hidden",
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflowWrap: "break-word",

          resize: "none",
          margin: 0,
          padding: "4px",
        }}

        onChange={(e) =>
          setNomeValues((prev) => ({
            ...prev,
            [equipamento]: e.target.value,
          }))
        }

      />



      {/* BOTÃO EDITAR DADOS */}

      <button
        type="button"
        className="botao-tabela-coluna_2 botao-descricao-edit"

        onClick={async (e) => {
          e.preventDefault();

          const result = await Swal.fire({
            title: "Alterar descrição?",
            text: `Deseja realmente alterar o campo ${campo}?`,
            iconHtml: '<span class="icone-duvida-tech">?</span>',

            allowOutsideClick: false,
            showCloseButton: true,
            showCancelButton: true,

            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",

            customClass: {
              popup: "swal-edicao-tech",
              icon: "swal-edicao-icon",
              title: "swal-edicao-title",
              htmlContainer: "swal-edicao-text",
              actions: "swal-edicao-actions",
              confirmButton: "swal-edicao-confirm",
              cancelButton: "swal-edicao-cancel",
              closeButton: "swal-edicao-close",
            },

            buttonsStyling: false,
          });



          if (result.isConfirmed) {
            setIsReadOnly(false);

            const {
              value: novoValor,
              isConfirmed,
              isDismissed
            } = await Swal.fire({

              title: "Editar descrição",
              text: `Altere o conteúdo do campo ${campo}.`,

              input: "textarea",
              inputValue: currentNome,

              inputAttributes: {
                maxlength: 29,
                rows: 3,
                placeholder: `Digite ${campo.toLowerCase()}...`,
              },

              showCancelButton: true,
              showCloseButton: true,
              allowOutsideClick: false,

              confirmButtonText: "Salvar",
              cancelButtonText: "Cancelar",

              buttonsStyling: false,

              customClass: {
                popup: "swal-editar-tech",
                title: "swal-editar-title",
                htmlContainer: "swal-editar-text",
                input: "swal-editar-input",
                actions: "swal-editar-actions",
                confirmButton: "swal-editar-confirm",
                cancelButton: "swal-editar-cancel",
                closeButton: "swal-editar-close",
              },

              didOpen: () => {
                const textarea = Swal.getInput();

                if (!textarea) return;

                const counter = document.createElement("div");

                counter.className = "swal-editar-counter";

                const atualizarContador = () => {
                  counter.textContent = `${textarea.value.length} / 29`;
                };

                textarea.parentNode.appendChild(counter);

                atualizarContador();

                textarea.addEventListener("input", atualizarContador);
              },
            });
            if (isConfirmed) {
              if (!novoValor || novoValor.trim() === "") {
                // Confirmação extra para salvar vazio
                const confirmEmpty = await Swal.fire({
                  title: "Tem certeza?",
                  text: `Isso apagará o dado anterior e deixará o campo ${campo} vazio.`,
                  icon: "warning",
                  customClass: {
                    popup: "confirma-edicao-obs",
                    htmlContainer: "swal2-html-container",
                  },

                  showCancelButton: true,
                  confirmButtonText: "Sim, deixar vazio",
                  cancelButtonText: "Cancelar",
                  confirmButtonColor: "#2563eb",
                  cancelButtonColor: "#9ca3af",

                });

                if (confirmEmpty.isConfirmed) {
                  setNomeValues((prev) => ({
                    ...prev,
                    [equipamento]: "",
                  }));

                  try {
                    await api.put(`nome/${id}`, { nome: "" });
                    toast.success(`Campo ${campo} apagado com sucesso`);
                  } catch (error) {
                    console.error("Erro ao salvar nome:", error);
                    toast.error("Erro ao salvar nome");
                  }
                }
              } else {
                // Salvar valor preenchido normalmente
                const valorFinal = novoValor.trim();
                setNomeValues((prev) => ({
                  ...prev,
                  [equipamento]: valorFinal,
                }));

                try {
                  await api.put(`nome/${id}`, {
                    nome: valorFinal
                  });

                  toast.success(
                    `Alteração no campo: ${campo} salva com sucesso!`
                  );

                } catch (error) {

                  console.error("========== ERRO DESCRIÇÃO ==========");
                  console.error("STATUS:", error.response?.status);
                  console.error("DATA:", error.response?.data);
                  console.error("URL:", error.config?.url);
                  console.error("REQUEST:", error.config?.data);
                  console.error("ERRO:", error);

                  toast.error(
                    error.response?.data?.error ||
                    error.response?.data?.message ||
                    `Erro ao salvar ${campo}`
                  );
                }
              }
              setIsReadOnly(true);
            }

            if (isDismissed) {
              setIsReadOnly(true);
            }
          } else {
            setIsReadOnly(true);
          }
        }}
      >

      </button>

    </form>
  );
}

export default CampoEditavel_Desc;
export { CampoEditavel_Obs };
